"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

var PropertyOptionButtons = function PropertyOptionButtons(_ref) {
  var question = _ref.question,
      objectProperty = _ref.objectProperty,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return _react.default.createElement("div", null, objectProperty.get('options').map(function (option) {
    return _react.default.createElement(_UISelectableBox.default, {
      key: option.get('value'),
      selected: question.selected.includes(option.get('value')),
      className: "p-all-1 m-left-0 m-bottom-2 m-right-2",
      style: {
        minWidth: 50
      },
      onClick: function onClick() {
        return onChange(option.get('value'));
      },
      disabled: disabled,
      "data-selenium-test": "q-and-a-quick-answer"
    }, _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center"
    }, _react.default.createElement(_Small.default, null, option.get('label'))));
  }));
};

PropertyOptionButtons.propTypes = {
  objectProperty: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  onChange: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired
};
var _default = PropertyOptionButtons;
exports.default = _default;
module.exports = exports.default;